import React, { FC } from 'react';
import cls from 'classnames';

import { LegalEllipsizerProps } from './LegalEllipsizer.types';
import { LegalString } from '../legalString';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

export const classNames = getClassNames('sds-legal-ellipsizer', ['expand-button']);

const LegalEllipsizer: FC<LegalEllipsizerProps> = (props) => {
	const { className, expandText, onExpand, ...rest } = props;

	return (
		<button
			onClick={onExpand}
			className={cls(getRootClassListFromProps(classNames, props), className)}
		>
			<LegalString {...rest} />
			<span className={classNames.expandButton}>
				...
				<span>{expandText}</span>
			</span>
		</button>
	);
};

LegalEllipsizer.displayName = 'LegalEllipsizer';

export default LegalEllipsizer;
